import { render, staticRenderFns } from "./TheAvatar.vue?vue&type=template&id=fe24c610&scoped=true&"
import script from "./TheAvatar.vue?vue&type=script&lang=ts&"
export * from "./TheAvatar.vue?vue&type=script&lang=ts&"
import style0 from "./TheAvatar.vue?vue&type=style&index=0&id=fe24c610&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe24c610",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EsNotificationBubble: require('/app/src/components/common/EsNotificationBubble.vue').default})
